import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, FormControlLabel, Checkbox} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { getTabScrollButtonUtilityClass } from "@mui/material";
import { useState, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import { fetchTripbyId, fetchHotels, fetchdestHotels, fetchdestHotelsbyDest, fetchTours, fetchdestTours, fetchdestToursbyDest, fetchDest, addquoteData, fetchcurrency, fetchCurrencyData, updateCurrencyData} from "../api/customerapi";
import {formatDate2, identifydest, gettcs} from "./date.js"

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Quotedataentry = () => {

    const classes = useStyles();
    const preURL=document.referrer;
    const urlarray=preURL.split("/");
    const tripid=urlarray[urlarray.length-1];
    const [oldcurrency, setoldcurrency]=useState({})
    const [daydata, setdaydata]=useState([])
    const [flightdata, setflightdata]=useState([])
    const [quoteData, setquoteData] =useState({})
    const [tripData, settripData]=useState({})
    const [currency, setcurrency]=useState({})
    const [cities, setcities]=useState([])
    const [listtourData, setlisttourData] =useState([{}])
    const [listhotelData, setlisthotelData]=useState([{}])
    const [price, setprice]=useState({
        total:0,
        perperson:0,
        percwb:0,
        percnb:0,
        airfare:0,
        taxes:0,
        landprice:0,
        otheritems:0,
        tcs:0
    })
    const [costprice, setcostprice]=useState({
        total:0,
        profit:0,
        airfare:0,
        taxes:0,
        landprice:0,
        otheritems:0,
        profit_type:"Value"
    })
    
    const getTrip = async (id) => {
        try{
        const data = await fetchTripbyId(id);
        settripData(data.data)
    }catch(err){
        console.log(err)
      }
        
    }

    

    const getCities = async () => {
        try{
        const data = await fetchDest();
        //console.log(data.data);
        const citylist= data.data.map(arr => arr.dest[0] == tripData.primary_destination ? [arr.cities] : [])
        const citylist2=citylist?.filter(arr => arr.length !==0 )
        const citylist3=citylist2[0]
        setcities(citylist3 ? [...citylist3[0]] :[])
        if(tripData.secondary_destinations){
            const seccitylist= data.data.map(arr => arr.dest[0] == tripData.secondary_destinations ? [arr.cities] : [])
            const seccitylist2=seccitylist?.filter(arr => arr.length !==0 )
            const seccitylist3=seccitylist2[0]
            console.log(seccitylist3)
            if (seccitylist3.length > 0) {
                //cities.push(...seccitylist3[0])
                setcities([...citylist3[0],...seccitylist3[0]])
            }
        }
    }catch(err){
        console.log(err)
      }
    }

    const getTours = async () => {
        try{
        const data = await fetchTours();
        const tourlist= data.data.filter(arr => arr.tour_destination == tripData.primary_destination)

        setlisttourData(tourlist)
        
        if(tripData.secondary_destinations){
            const tourlist2= data.data.filter(arr => arr.tour_destination == tripData.secondary_destinations)
            setlisttourData([...tourlist,...tourlist2])
        }
        //console.log(listtourData)
    }catch(err){
        console.log(err)
      }
    }

    const getdestTours = async (tripid) => {
        try{
        const data = await fetchdestTours(tripid);
        //const tourlist= data.data.filter(arr => arr.tour_destination == tripData.primary_destination)

        setlisttourData(data.data)
        
        if(tripData.secondary_destinations){
            const data2 = await fetchdestToursbyDest(tripData.secondary_destinations);
            //const tourlist2= data.data.filter(arr => arr.tour_destination == tripData.secondary_destinations)
            setlisttourData([...data.data,...data2.data])
        }
        //console.log(listtourData)
    }catch(err){
        console.log(err)
      }
    }

    const getHotels = async () => {
        try{
        const data = await fetchHotels();
        //console.log("123");
        const hotellist= data.data.filter(arr => arr.hotel_destination == tripData.primary_destination)
        setlisthotelData(hotellist)
        if(tripData.secondary_destinations){
            const hotellist2= data.data.filter(arr => arr.hotel_destination == tripData.secondary_destinations)
            setlisthotelData([...hotellist,...hotellist2])
        }
        console.log(listhotelData)
    }catch(err){
        console.log(err)
      }
      }

    const getdestHotels = async (tripid) => {
        try{
        //console.log(tripid)
        const data = await fetchdestHotels(tripid);
        let sortedHotels = data.data.sort((a, b) => {
            if (a.hotel_name < b.hotel_name) {
                return -1;
            }
            if (a.hotel_name > b.hotel_name) {
                return 1;
            }
            return 0;
        });
        
        //const hotellist= data.data.filter(arr => arr.hotel_destination == tripData.primary_destination)
        setlisthotelData(sortedHotels)
        if(tripData.secondary_destinations){
            const data2 = await fetchdestHotelsbyDest(tripData.secondary_destinations);
            let sortedHotels2 = data2.data.sort((a, b) => {
                if (a.hotel_name < b.hotel_name) {
                    return -1;
                }
                if (a.hotel_name > b.hotel_name) {
                    return 1;
                }
                return 0;
            });;
            //const hotellist2= data2.data.filter(arr => arr.hotel_destination == tripData.secondary_destinations)
            setlisthotelData([...sortedHotels,...sortedHotels2])
        }
        
        //console.log(listhotelData)
    }catch(err){
        console.log(err)
      }
      }

   

    useEffect(() => {
        
        getTrip(tripid)
        getCurrency()
        
    }, [])

    useEffect(() => {
        
        getCities()
        getdestHotels(tripid)
        getdestTours(tripid)
        //getHotels()
        //getTours(tripid)
    }, [daydata])
    
const defaultdate=(index)=> {
        //var d=new Date(daydata[0]?.date ? daydata[0].date : (tripData.trip_start_date===undefined ? "2021-01-01" : tripData.trip_start_date.split("T").slice(0,1)))
       // if (index > 0){
        var d=new Date(tripData.trip_start_date.split("T").slice(0,1))
        //console.log(d)
        d.setDate(d.getDate()+index)
        const fupy=d.getFullYear()
        const fupm=(d.getMonth()+1) < 10? ("0"+(d.getMonth()+1)) : (d.getMonth()+1)
        const fupdt=d.getDate() <10 ? ("0"+d.getDate()) : d.getDate()
        const dt=(fupy+"-"+fupm+"-"+fupdt)
        return dt
    
        
}

    const addday =() =>{
        //console.log(cpdata)
        
        setdaydata(daydata.length==0? [{id:uuidv4(), date:defaultdate(daydata.length)}]: [...daydata,{id:uuidv4(), date:defaultdate(daydata.length)}]) 
        console.log(daydata)
    }

    const removeday =() =>{
        //console.log(cpdata)
        setdaydata([...daydata].slice(0,daydata.length-1))
    }

    const addflight =() =>{
        //console.log(cpdata)
        
        setflightdata(flightdata.length==0? [{id:uuidv4()}]: [...flightdata,{id:uuidv4()}]) 
    }

    const removeflight =() =>{
        //console.log(cpdata)
        setflightdata([...flightdata].slice(0,flightdata.length-1))
    }

    const sourcedatechange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, source_date:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const destdatechange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, destination_date:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const sourcetimechange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, source_time:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const desttimechange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, destination_time:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const sourceaptchange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, source_airport:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const destaptchange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, destination_airport:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const airlinechange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, airline:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const stopchange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, stops:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const haltchange =(e,tid) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, halt:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const daydatechange =(e,tid) =>{
  
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, date:e.target.value}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const daycitychange =(e,tid, id) =>{
  
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, city:e.target.value}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const dayhotelchange =(e,tid) =>{
  
        const newdata=daydata[tid]
        const category=listhotelData.map(hotel => hotel.hotel_name == e.target.value ? hotel.star_category :0)
        const category2=category.filter(cat => cat>0)
        const hid=listhotelData.filter(hotel => hotel.hotel_name == e.target.value)
        const newitem= {...newdata, hotel_name:e.target.value, hotel_category: category2[0], hotel_id:hid[0].hotel_id}
        // console.log(category)
        // console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata)
        //setdata([...data, data[tid]=newitem])
        
    }

    const daytourchange =(e,tid, id) =>{
  
        const newdata=daydata[tid]
        const desc=listtourData.filter(tour => tour.tour_name == e.target.value ? tour.tour_description : "")
        const newitem= {...newdata, tour_name:e.target.value, tour_description:desc[0] ? desc[0].tour_description : "", tour_id:desc[0] ? desc[0].tour_id : 0}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //getdescvalue(tid)
        //setdata([...data, data[tid]=newitem])
        //console.log(daydata)
    }

    const daymealchange =(e,tid) =>{
  
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, meal_plan:e.target.value}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const dayroomchange =(e,tid) =>{
  
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, room_type:e.target.value}
        
        daydata[tid]=newitem
        setdaydata(daydata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const getCurrency=async()=>{
        try{
        const data= await fetchCurrencyData();
        //console.log(data.data)
        setoldcurrency(data.data[0])
        console.log(oldcurrency)
        if((new Date().getTime())-(new Date(data.data[0].date).getTime())>1000*60*60*24){
            console.log("Fetching data for cuurency")
            const data2 = await fetchcurrency("USD");
            
            const data3 = await fetchcurrency("SGD");
           
            const data4 = await fetchcurrency("THB");
     
            const data5 = await fetchcurrency("AED");
            
            const data6 = await fetchcurrency("IDR");

            const data7 = await fetchcurrency("EUR");
            setoldcurrency({...oldcurrency, date:new Date(),usd_inr:data2.data.conversion_rates.INR, sgd_inr:data3.data.conversion_rates.INR, thb_inr:data4.data.conversion_rates.INR, aed_inr:data5.data.conversion_rates.INR, idr_inr:data6.data.conversion_rates.INR, eur_inr:data7.data.conversion_rates.INR})
            const tempcurrency={date:new Date(),usd_inr:data2.data.conversion_rates.INR, sgd_inr:data3.data.conversion_rates.INR, thb_inr:data4.data.conversion_rates.INR, aed_inr:data5.data.conversion_rates.INR, idr_inr:data6.data.conversion_rates.INR, eur_inr:data7.data.conversion_rates.INR}
            console.log(oldcurrency)
            const updatecurrenyResponse= await updateCurrencyData(data.data[0]._id, tempcurrency);
            
            if(updatecurrenyResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                
            }
            else{
                alert("Unable to refresh currency data");
                
            }
        }else{
            console.log("New data will be fetched after 24 hours")
        }
    }catch(err){
        console.log(err)
      }
       }

       const getER=async(e)=>{
        if(currency.currency_name=="USD"){
    
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.usd_inr+1)).toFixed(2)})
      }else if(currency.currency_name=="SGD"){
        
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.sgd_inr+1)).toFixed(2)})
      }else if(currency.currency_name=="AED"){
    
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.aed_inr+0.4)).toFixed(2)})
      }else if(currency.currency_name=="THB"){
    
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.thb_inr+0.1)).toFixed(2)})
      }else if(currency.currency_name=="IDR"){
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.idr_inr).toFixed(2))})
      }else if(currency.currency_name=="EUR"){
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.eur_inr+1.5).toFixed(2))})
      }
      
    }


    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        const finalprice={...price, tcs: gettcs(tripData), total:parseInt(price.airfare)+parseInt(price.landprice)+parseInt(price.otheritems)+parseInt(price.taxes)}
        const finalquoteData= {...quoteData, flight: flightdata, day:daydata, cust_name:tripData.cust_name, trip_start_date:tripData.trip_start_date,
        cust_id:tripData.cust_id, primary_destination:tripData.primary_destination, duration:tripData.duration, trip_owner:tripData.trip_owner, quote_price:finalprice,
        trip_requirements:tripData.trip_requirements, number_adults:tripData.number_adults, number_child:tripData.number_child, trip_id:tripData.trip_id, 
        trip_status:tripData.trip_status,cost_price:costprice,
        child_age:tripData.child_age,
        inclusions_arr:quoteData.inclusions ? quoteData.inclusions.split("||") :[], 
        exclusions_arr:quoteData.exclusions ? quoteData.exclusions.split("||"): [], 
        tnc_arr:quoteData.tnc ? quoteData.tnc.split("||"): [], 
        createdAt: new Date(),
        updatedAt:new Date(),
        cust_notes_arr:quoteData.cust_notes ? quoteData.cust_notes.split("||"): [], 
        trip_details:tripData._id,
        cancellation_policy_arr:quoteData.cancellation_policy ? quoteData.cancellation_policy.split("||") : []};
        // const addhotelResponse= await addHotel(finalhotelData);
        //console.log(sData);
        console.log(finalquoteData);
        const addQuoteResponse= await addquoteData(finalquoteData);
        
        if(addQuoteResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Quote created for trip with trip id "+addQuoteResponse.data.trip_id+" with quote id: "+addQuoteResponse.data.quote_id);
            window.location = ("/quotedataentry/"+addQuoteResponse.data.quote_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
    }catch(err){
        console.log(err)
      }
    }

    // const gettcs=()=>{
    //     var convdate=""
    //     var t=identifydest(tripData.primary_destination)
    //     if(t){
    //         if(tripData.trip_status=="Converted"){
    //             convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
    //         }else if(tripData.trip_status=="Closed"){
    //           convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
    //         }

            
    //         if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
    //             return price?(price.landprice*1.05)*0:0
    //         }else{
    //             return price?(price.landprice*1.05)*0.05:0
    //         }
    //         //console.log("ABC")
           
    //         //setprice({...price,tcs:price.landprice*0.05})
           
    //     }else{
    //         //console.log("DEF")
    //         //setprice({...price,tcs:0})
    //         return 0
    //     }
    // }

    return ( 
        <div>
        <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}> Create New Quote (Trip Id: {tripData.trip_id})</Typography>
        <form onSubmit={handleSubmit}>
        
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard"  label="Header" value={quoteData.quote_header} className={classes.textField} onChange={(e) => setquoteData({...quoteData, quote_header:e.target.value})}/>
        <TextField variant="standard"  disabled label="Customer" InputLabelProps={{ shrink: true }} value={tripData.cust_name} className={classes.textField} />
        <TextField variant="standard"  disabled label="Destination" InputLabelProps={{ shrink: true }} value={tripData.primary_destination} className={classes.textField} />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard"  disabled label="Start date" InputLabelProps={{ shrink: true }} value={((tripData.trip_start_date)===undefined ? "" : tripData.trip_start_date.split("T")).slice(0,1)} className={classes.textField} />
        <TextField variant="standard"  disabled label="Duration" InputLabelProps={{ shrink: true }} value={tripData.duration} className={classes.textField} />
        <FormControlLabel control={<Checkbox color="primary"/>}  value={quoteData.favorite} label="Set favorite for re-use" onChange={(e)=> setquoteData({...quoteData, favorite: e.target.checked})}/>
        </FormGroup>
        {quoteData.favorite ?
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard"  label="Identifier" InputLabelProps={{ shrink: true }} value={quoteData.quote_identifier} className={classes.textField} onChange={(e) => setquoteData({...quoteData, quote_identifier:e.target.value})}/>
        </FormGroup>
        :""}

        <Typography variant="h4" align="center" className={classes.headertext}> Flight</Typography>
        {flightdata.map(item => {
                return <div>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Start Date"  id={flightdata.indexOf(item)} type="date" InputLabelProps={{ shrink: true }} value={item.source_date} className={classes.textField} onChange={(e) => sourcedatechange(e,e.target.id)}/>
                <TextField variant="standard"   label="Start Time"   id={flightdata.indexOf(item)} type="time" InputLabelProps={{ shrink: true }} value={item.source_time} className={classes.textField} onChange={(e) => sourcetimechange(e,e.target.id)}/>
                <TextField variant="standard"   label="Source Airport"   id={flightdata.indexOf(item)} value={item.source_airport} className={classes.textField} onChange={(e) => sourceaptchange(e,e.target.id)}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="End Date"  id={flightdata.indexOf(item)} type="date" InputLabelProps={{ shrink: true }} value={item.destination_date} className={classes.textField} onChange={(e) => destdatechange(e,e.target.id)}/>
                <TextField variant="standard"   label="End Time"   id={flightdata.indexOf(item)} type="time" InputLabelProps={{ shrink: true }} value={item.destination_time} className={classes.textField} onChange={(e) => desttimechange(e,e.target.id)}/>
                <TextField variant="standard"   label="Destination Airport"   id={flightdata.indexOf(item)} value={item.destination_airport} className={classes.textField} onChange={(e) => destaptchange(e,e.target.id)}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Airline"  id={flightdata.indexOf(item)}  value={item.airline} className={classes.textField} onChange={(e) => airlinechange(e,e.target.id)}/>
                <TextField variant="standard"   label="Stops (number)"   id={flightdata.indexOf(item)} value={item.stops} className={classes.textField} onChange={(e) => stopchange(e,e.target.id)}/>
                <TextField variant="standard"   label="Halt"   id={flightdata.indexOf(item)} value={item.halt} className={classes.textField} onChange={(e) => haltchange(e,e.target.id)}/>
            </FormGroup>

            
            <Typography variant="h4" align="center" className={classes.headertext}> ------------------------------------------------------------------------------------------- </Typography>
            </div>})}
           
            <FormGroup row className={classes.formgroup}>
                
                <Button variant="outlined" color="primary"  className={classes.button} onClick={addflight}> + Tranche</Button>
                <Button variant="outlined" color="secondary" className={classes.button} onClick={removeflight}> - Tranche</Button>
                
            </FormGroup>

          
        <Typography variant="h4" align="center" className={classes.headertext}> Day-wise Itinerary</Typography>
        
       {daydata.map(item => {
                return <div>
            <FormGroup row className={classes.formgroup}>
                
                <TextField variant="standard"  label="Date"  id={daydata.indexOf(item)} type="date" InputLabelProps={{ shrink: true }} disabled value={item.date} className={classes.textField} onChange={(e) => daydatechange(e,e.target.id)}/>
                            
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="city">City</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="city"  name={daydata.indexOf(item)} value={item.city} onChange={(e) => daycitychange(e,e.target.name,item.id)}>
                {cities?.map(city => {
                    return <MenuItem value={city}>{city}</MenuItem>})}
                </Select>
                </FormControl>  
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="tour">Tour Name</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="tour"  name={daydata.indexOf(item)} value={item.tour_name} onChange={(e) => daytourchange(e,e.target.name, item.id)}>
                {listtourData?.filter(tour => tour.tour_city == item.city).map(tour => {
                    return <MenuItem value={tour.tour_name}>{tour.tour_name}</MenuItem>})}
                </Select>
                </FormControl> 
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="hotel name">Hotel Name</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="hotel name"  name={daydata.indexOf(item)} value={item.hotel_name} onChange={(e) => dayhotelchange(e,e.target.name)}>
                {listhotelData?.filter(hotel => hotel.hotel_city == item.city).map(hotel => {
                    return <MenuItem value={hotel.hotel_name}>{hotel.hotel_name}</MenuItem>})}
                       
                </Select>
                </FormControl>  
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="meal">Meal Plan</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="meal"  name={daydata.indexOf(item)} value={item.meal_plan} onChange={(e) => daymealchange(e,e.target.name)}>
                    <MenuItem value={"No meals"}>No meals</MenuItem>
                    <MenuItem value={"Dinner"}>Dinner</MenuItem>
                    <MenuItem value={"Breakfast"}>Breakfast</MenuItem>
                    <MenuItem value={"Breakfast and Dinner"}>Breakfast and Dinner</MenuItem>  
                    <MenuItem value={"Lunch and Dinner"}>Lunch and Dinner</MenuItem> 
                    <MenuItem value={"Breakfast, Lunch and Dinner"}>Breakfast, Lunch and Dinner</MenuItem>   
                    <MenuItem value={"All Inclusive"}>All Inclusive</MenuItem>   
                </Select>
                </FormControl> 
                <TextField variant="standard" label="Room Details"   id={daydata.indexOf(item)} value={item.room_type} className={classes.textField} onChange={(e) => dayroomchange(e,e.target.id)}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined" disabled label="Tour description"  id={daydata.indexOf(item)} InputLabelProps={{ shrink: true }} value={item.tour_description}  className={classes.textArea} fullWidth multiline rows={4}  />
            </FormGroup>

                <Typography variant="h4" align="center" className={classes.headertext}> ------------------------------------------------------------------------------------------- </Typography>
            </div>})}
           
            <FormGroup row className={classes.formgroup}>
                
                <Button variant="outlined" color="primary"  className={classes.button} onClick={addday}> + Tranche</Button>
                <Button variant="outlined" color="secondary" className={classes.button} onClick={removeday}> - Tranche</Button>
               
            </FormGroup>
            <Typography variant="h4" align="center" className={classes.headertext}> Price Information</Typography>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  label="Airfare (number)" value={price.airfare} className={classes.textField} onChange={(e) => setprice({...price, airfare:e.target.value})}/>
            <TextField variant="standard"  label="land (number)" value={price.landprice} className={classes.textField} onChange={(e) => setprice({...price, landprice:e.target.value})}/>
            <TextField variant="standard"  label="Other Items(number)" value={price.otheritems} className={classes.textField} onChange={(e) => setprice({...price, otheritems:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  label="Taxes (number)" value={price.taxes} className={classes.textField} onChange={(e) => setprice({...price, taxes:e.target.value})}/>
            <TextField variant="standard"  disabled label="TCS (number)" value={gettcs(tripData)} className={classes.textField} />
            <TextField variant="standard"  disabled label="Total (number)" value={parseInt(price.airfare)+parseInt(price.landprice)+parseInt(price.otheritems)+parseInt(price.taxes)} className={classes.textField} />
            
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            
            <TextField variant="standard"  label="Per Adult (number)" value={price.perperson} className={classes.textField} onChange={(e) => setprice({...price, perperson:e.target.value})}/>
            <TextField variant="standard"  label="Per Child (CWB) (number)" value={price.percwb} className={classes.textField} onChange={(e) => setprice({...price, percwb:e.target.value})}/>
            <TextField variant="standard"  label="Per Child (CNB) (number)" value={price.percnb} className={classes.textField} onChange={(e) => setprice({...price, percnb:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  label="Promo Code" InputLabelProps={{ shrink: true }} value={quoteData.quote_discount_type} className={classes.textField} onChange={(e) => setquoteData({...quoteData, quote_discount_type:e.target.value})}/>
            <TextField variant="standard"  label="Discount (number)" InputLabelProps={{ shrink: true }} value={quoteData.quote_discount} className={classes.textField} onChange={(e) => setquoteData({...quoteData, quote_discount:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Customer Notes"  value={quoteData.cust_notes} className={classes.textArea} fullWidth multiline rows={2} onChange={(e) => setquoteData({...quoteData, cust_notes:e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Inclusions"  value={quoteData.inclusions} className={classes.textArea} fullWidth multiline rows={5} onChange={(e) => setquoteData({...quoteData, inclusions:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Exclusions"  value={quoteData.exclusions} className={classes.textArea} fullWidth multiline rows={5} onChange={(e) => setquoteData({...quoteData, exclusions:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Terms & Conditions"  value={quoteData.tnc} className={classes.textArea} fullWidth multiline rows={5} onChange={(e) => setquoteData({...quoteData, tnc:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Cancellation Policy"  value={quoteData.cancellation_policy} className={classes.textArea} fullWidth multiline rows={5} onChange={(e) => setquoteData({...quoteData, cancellation_policy:e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Internal Notes"  value={quoteData.internal_notes} className={classes.textArea} fullWidth multiline rows={2} onChange={(e) => setquoteData({...quoteData, internal_notes:e.target.value})}/>
            </FormGroup>
            
            <Typography variant="h4" align="center" className={classes.headertext}> Cost Price Calculation</Typography>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  label="Airfare (number)" value={costprice.airfare} className={classes.textField} onChange={(e) => setcostprice({...costprice, airfare:e.target.value})}/>
            <TextField variant="standard"  label="land (number)" value={costprice.landprice} className={classes.textField} onChange={(e) => setcostprice({...costprice, landprice:e.target.value})}/>
            <TextField variant="standard"  label="Other Items(number)" value={costprice.otheritems} className={classes.textField} onChange={(e) => setcostprice({...costprice, otheritems:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  label="Taxes (number)" value={costprice.taxes} className={classes.textField} onChange={(e) => setcostprice({...costprice, taxes:e.target.value})}/>
            
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="profittype">Profit calc Type</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="profittype"
            
              onChange={(e) =>
                setcostprice({ ...costprice, profit_type: e.target.value })
              }
            >
              <MenuItem value={"Value"}>Value</MenuItem>
              <MenuItem value={"Percentage"}>Percentage</MenuItem>
            </Select>
          </FormControl>
            <TextField variant="standard"  label="Profit (number)" value={costprice.profit} className={classes.textField} onChange={(e) => setcostprice({...costprice, profit:e.target.value})}/>
            <TextField variant="standard"  disabled label="Total (number)" 
            value={costprice.profit_type=="Value"?(parseInt(costprice.airfare)+parseInt(costprice.landprice)+parseInt(costprice.otheritems)+parseInt(costprice.taxes)+parseInt(costprice.profit)):
            (((parseInt(costprice.airfare)+parseInt(costprice.landprice)+parseInt(costprice.otheritems)+parseInt(costprice.taxes))*(1+(costprice.profit)/100)))
            } className={classes.textField} />
            
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <Typography variant="h6" align="center" className={classes.headertext}> USD to INR: {oldcurrency?.usd_inr} || SGD to INR: {oldcurrency?.sgd_inr} || AED to INR:{oldcurrency?.aed_inr} || THB to INR:{oldcurrency?.thb_inr} || IDR to INR:{oldcurrency?.idr_inr} || EUR to INR:{oldcurrency?.eur_inr}</Typography>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  label="Value in currency" className={classes.textField} onChange={(e) => setcurrency({...currency, currency_value:e.target.value})}/>
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="choosecurrency">Choose Currency</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="choosecurrency"
            value={currency?.currency_name}
              onChange={(e) =>
                setcurrency({ ...currency, currency_name: e.target.value })
              }
            >
              <MenuItem value={"USD"}>USD</MenuItem>
              <MenuItem value={"SGD"}>SGD</MenuItem>
              <MenuItem value={"THB"}>THB</MenuItem>
              <MenuItem value={"AED"}>AED</MenuItem>
              <MenuItem value={"IDR"}>IDR</MenuItem>
            </Select>
          </FormControl>
            <Button variant="contained" color="primary" className={classes.button} onClick={(e) =>getER(e)}>Convert</Button>
            <TextField variant="standard"  InputLabelProps={{ shrink: true }} label="Value in INR" value={currency?.newvalue} className={classes.textField}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href={"/tripdataentry/"+tripid} variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                
            </FormGroup>
        </form>
        </Paper>
        </div>
     );
}
 
export default Quotedataentry;